<template>
  <div class="app">
    <router-view v-wechat-title="$route.meta.title + '-数字资源库'"/>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted() {
    // this.$router.beforeEach((to, from, next) => {
    //
    // })
  },
  methods: {}
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
}

body, html {
  height: 100%;
  position: relative;
}

/*滚动条的宽度*/
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/*滚动条的滑块*/
::-webkit-scrollbar-thumb {
  background-color: #a1a3a9;
  border-radius: 4px;
}

.login-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: auto auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

.login_title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.login_remember {
  margin: 0px 0px 35px 0px;
  text-align: left;
}

.app {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  position: relative;

}
</style>
